module.exports = __webpack_public_path__ + "img/0527-h.67aa81dc.svg";